function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { forwardRef } from 'react';
import BaseButton from '../base-button';
import warn from '../util/warn';
import { jsx as ___EmotionJSX } from "@emotion/core";
var hrefWarning = warn('development');
var LinkButton = /*#__PURE__*/forwardRef(function (props, ref) {
  if (!props.href) {
    hrefWarning("You've added a LinkButton without an href which creates an accessibility violation, please change to a Button instead");
  }

  return ___EmotionJSX(BaseButton, _extends({
    forwardRef: ref
  }, props, {
    type: "link"
  }));
});
LinkButton.displayName = 'LinkButton';
export default LinkButton;